<template>
  <div class="content">
    <h2><b-icon icon="apps" /> Browse Products</h2>
    <products-table :category="category" />
  </div>
</template>

<script>
import ProductsTable from "@/components/ProductsTable"

export default {
  name: 'Products',
  components: {
    ProductsTable
  }
}
</script>

<style scoped>

</style>
